import {Subject} from 'rxjs';

export const sharedMapSubjects$ = {
    devices: new Subject(),
    positions: new Subject(),
};
